import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  max-width: 500px;
  width: ${props => props.width || '100%'};
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  padding: 20px;
  backdrop-filter: blur(10px);
  color: var(--text-primary);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1DA1F2, #00A9E0);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
`;

const NameWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.span`
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 4px;

  svg { width: 16px; height: 16px; color: #1DA1F2; }
`;

const Handle = styled.span`
  color: var(--text-muted);
  font-size: 14px;
`;

const TwitterIcon = styled.svg`
  width: 24px;
  height: 24px;
  color: #1DA1F2;
`;

const TweetText = styled.p`
  font-size: 15px;
  line-height: 1.5;
  margin: 0 0 15px 0;
  white-space: pre-wrap;

  .hashtag { color: #1DA1F2; cursor: pointer; }
  .link { color: #1DA1F2; cursor: pointer; }
`;

const TweetMeta = styled.div`
  font-size: 14px;
  color: var(--text-muted);
  border-bottom: 1px solid rgba(255,255,255,0.05);
  padding-bottom: 15px;
  margin-bottom: 15px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-around;
  color: var(--text-muted);

  .action-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
    transition: color 0.2s;

    svg { width: 20px; height: 20px; }
    
    &:hover { color: #1DA1F2; }
    &:hover.retweet { color: #17bf63; }
    &:hover.like { color: #e0245e; }
  }
`;

const TwitterFeedWidget = ({ node }) => {
  const content = node.content?.text || 'Willkommen in der Zukunft der Vernetzung! 🚀 Unser neues 5G Netz ist ab sofort flächendeckend in München verfügbar. \n\nMehr Infos im Thread 👇 \n#5G #Telefónica #Innovation';
  const username = node.content?.username || 'Telefónica Germany';
  const handle = node.content?.handle || '@tef_germany';

  // Highlight hashtags
  const formattedText = content.split(/(\s+)/).map((word, i) => {
    if (word.startsWith('#')) return <span key={i} className="hashtag">{word}</span>;
    if (word.startsWith('http')) return <span key={i} className="link">{word}</span>;
    return word;
  });

  return (
    <Wrapper align={node.style?.desktop?.align}>
      <Header>
        <UserInfo>
          <Avatar>TEF</Avatar>
          <NameWrap>
            <Name>
              {username}
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            </Name>
            <Handle>{handle}</Handle>
          </NameWrap>
        </UserInfo>
        <TwitterIcon viewBox="0 0 24 24" fill="currentColor"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></TwitterIcon>
      </Header>
      
      <TweetText>{formattedText}</TweetText>
      <TweetMeta>12:45 PM · 18. März 2026 · X for iPhone</TweetMeta>
      
      <Actions>
        <div className="action-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg> 42</div>
        <div className="action-btn retweet"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 1l4 4-4 4"></path><path d="M3 11V9a4 4 0 014-4h14"></path><path d="M7 23l-4-4 4-4"></path><path d="M21 13v2a4 4 0 01-4 4H3"></path></svg> 12</div>
        <div className="action-btn like"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"></path></svg> 405</div>
        <div className="action-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg></div>
      </Actions>
    </Wrapper>
  );
};

registry.register('twitter_feed', {
  label: 'X / Twitter Post',
  icon: '🐦',
  category: 'social',
  defaultContent: { username: 'Telefónica Germany', handle: '@tef_germany' },
  defaultStyle: { desktop: { align: 'center' } },
  render: TwitterFeedWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Tweet Inhalt', fields: [{name:'content.username', label:'Anzeigename', type:'text'}, {name:'content.handle', label:'@Handle', type:'text'}, {name:'content.text', label:'Tweet Text', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Links', value:'left'},{label:'Zentriert', value:'center'}]}] }] }
  ]
});
